module.exports = __webpack_public_path__ + "img/commercial.edd32d22.svg";